<template>
   <div class="bom-list-container">
    <div class="empty-bom-list">
      <div v-if="!isBomDetailOpen && loadingBomList" style="padding-left: 33rem; padding-top: 20rem">
    <loading-circle />
      </div>
      <div v-else-if="!isBomDetailOpen && !loadingBomList && !getBomList.length" style="padding-left: 33rem; padding-top: 20rem">
    <h3>
      No bom found
    </h3>
  </div>
    <div v-else :class="['bom-item', { 'bom-item--collapsed': !isSidebarOpen }]">
    <template>
      <div v-if="!isSidebarOpen" class="collapsed-sidebar">
        <img v-tooltip="'Expand BOM List'" @click="handleSidebarToggle"
          src="~@/assets/images/icons/expand-sidebar.svg" width="13px" alt="" />
        <div class="divider" />
        <div class="vertical-text">
          <span>BOM LIST</span>
        </div>
        <div v-if="selectedBom" class="divider-light" />
        <div v-if="selectedBom" class="selectedProduct-viewer">
           <img
              v-if="getBomStateIcon(selectedBom)"
              :src="getBomStateIcon(selectedBom)"
              class="icon"
              v-tooltip="getBomStateTooltip(selectedBom)"
            />
          <div class="vertical-text-selected">{{ selectedBom.name }}</div>
        </div>
      </div>
      <div v-else>
     <div class="empty-bom-list__header s  ">
     <div class=" setting-header space-between p-2 v-center">
      <h2 class="setting-name py-1">BOM List</h2>
      <div class="action-icons">
        <img
          v-tooltip="'Collapse BOM List'"
          @click="handleSidebarToggle"
          src="~@/assets/images/icons/collapse-sidebar.svg"
          width="13px"
          alt=""
        />
      <img
        v-show="!createBomDisable"
        @click.stop="openCreateBom"
        v-tooltip="'Add BOM'"
        src="~@/assets/images/icons/add-new-icon.svg"
        width="20px"
        alt=""
      />
      </div>
     </div>
    </div>
      <div
      v-for="bom in getBomList"
        :key="bom.name"
        @click="openBomDetail(bom)">
        <settings-bar
          class="product-code-item"
          :selected="bom.id == selectedBomId"
          :title="bom.name"
        >
          <template #subtitle>
            <div class="erp-id elipsis-text" v-overflow-tooltip>
              ERP Id: {{ bom.erp_bom_id ? bom.erp_bom_id : '--' }}
            </div>
          </template>
          <template #actions>
            <img
              v-if="getBomStateIcon(bom)"
              :src="getBomStateIcon(bom)"
              class="icon"
              v-tooltip="getBomStateTooltip(bom)"
            />
          </template>
        </settings-bar>
    </div>
    </div>
    </template>
  </div>
  </div>
  <div  class="bom-detail-view">
<router-view />
</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Config from '@/config'
import loadingCircle from '../../../components/common/loadingCircle.vue'
import SettingsBar from '@/components/common/settingsBar.vue'
export default {
  components: { loadingCircle, SettingsBar },
  data: () => {
    return {
      OBSOLETE: Config.BOM_STATE_MAP.OBSOLETE,
      LOCK: Config.BOM_STATE_MAP.LOCK,
      loadingBomList: false
    }
  },
  inject: ['bomListSidebar'],
  watch: {
    '$route.params.productCode': function (newVal) {
      if (newVal) {
        this.$store.dispatch('projectBom/selectProductCodeAndFetchBoms', newVal)
      }
    }
  },
  computed: {
    ...mapGetters('projectBom', ['bomList', 'bomListLoading', 'bomSearchKeyword', 'selectedBomId', 'selectedProductCodeId']),
    ...mapGetters(['user']),
    createBomDisable () {
      if (this.user.projectLevelRole === 'ADMIN' ||
            this.user.projectLevelRole === 'COLLABORATOR' ||
            this.user.projectLevelRole === 'EDITOR') { return false } else return true
    },
    getBomList () {
      return this.bomList
        .filter((bom) => {
          if (!this.bomSearchKeyword || (this.bomSearchKeyword && bom.name.toLowerCase().includes(this.bomSearchKeyword))) {
            if (this.user.projectLevelRole !== 'ADMIN') {
              if (bom.state === 3 && bom.checked_out_by) {
                if (bom.checked_out_by !== this.user.userId && bom.bom_versions.length <= 1) {
                  return false
                }
              }
            }
            return true
          }
        }).map((bom) => {
          return {
            ...bom,
            stateValue: Config.STATE_MAP[bom.state]
          }
        })
    },
    selectedBom () {
      return this.bomList.find(bom => bom.id === this.selectedBomId) || null
    },
    isBomDetailOpen () {
      return !!this.$route.params.bomId || this.$route.matched.some(r => r.name === 'ProjectBomDetail')
    },
    isSidebarOpen () {
      return this.bomListSidebar.isOpen
    }
  },
  methods: {
    getBomStateIcon (bom) {
      if (bom.state === 2) return require('@/assets/images/icons/checkIn-file.svg')
      if (bom.state === 3) return require('@/assets/images/icons/checkout-file.svg')
      if (bom.state === 1) return require('@/assets/images/icons/locked-icon.svg')
      if (bom.state === 5) return require('@/assets/images/icons/checkin-icon.svg')
      if (bom.state === this.OBSOLETE) return require('@/assets/images/icons/obsolete-icon.svg')
      return null
    },
    getBomStateTooltip (bom) {
      if (bom.state === 2) return 'Bom is checked in'
      if (bom.state === 3) return 'Bom is checked out'
      if (bom.state === 1) return 'Bom is locked'
      if (bom.state === 5) return 'Bom is Released'
      if (bom.state === this.OBSOLETE) return 'Bom is Obsolete'
      return ''
    },
    openBomDetail (bom) {
      const productCodeId = this.$route.params.productCode || this.selectedProductCodeId
      this.$router.push(
        `/bom/project/${productCodeId}/bom/${bom?.id}${
          bom.bom_versions?.[0]?.id
            ? `?bomVersionId=${bom.bom_versions?.[0]?.id}`
            : ''
        }`
      )
    },
    openCreateBom () {
      const productCodeId = this.$route.params.productCode || this.selectedProductCodeId
      this.$router.push({
        path: `/bom/project/${productCodeId}/bom/new`
      })
    },
    setBaseData () {
      this.loadingBomList = true
      const productCodeId = this.$route.params.productCode ? this.$route.params.productCode : this.selectedProductCodeId
      if (productCodeId) {
        this.$store.dispatch('projectBom/setSelectedProductCodeId', productCodeId)
        this.$store.dispatch('projectBom/getBomList', { productCodeId })
      }
      this.loadingBomList = false
    },
    handleSidebarToggle () {
      this.bomListSidebar.isOpen = !this.bomListSidebar.isOpen
    }
  },
  mounted () {
    this.setBaseData()
  },
  created () {
    this.setBaseData()
  }
}
</script>

<style lang="scss" scoped >
.bom-item{
  min-width: 24rem;
  max-width: 25rem;
  height:100%;
  overflow: auto;
  // background-color: var(--bg-color);
  border: 1px solid var(--gray-bgcolor);
  border-left: none;
  border-top: none;
  transition: max-width 0.3s ease, min-width 0.3s ease;
  @media screen and (max-width: 1366px) {
    min-width: 14rem;
    max-width: 14rem;
  }

  .action-icons {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &--collapsed {
    min-width: 30px;
    max-width: 32px;
    overflow: hidden;
  }

  .collapsed-sidebar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 10px 0 0 0;

    .divider {
      height: 1px;
      width: 20px;
      background: #ebe6e7;
    }

    .divider-light {
      height: 1px;
      width: 20px;
      background: #ebe6e7;
    }

    .vertical-text {
      height: 75px;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;

      span {
        transform-origin: center;
        transform: rotate(-90deg);
        font-size: var(--text-xs1);
        letter-spacing: 1px;
        color: #99a1af;
        font-weight: bold;
      }
    }

    .selectedProduct-viewer {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;

      .icon {
        width: 15px;
      }

      .vertical-text-selected {
        writing-mode: sideways-lr;
        font-size: var(--text-xs1);
        color: #556072;
        font-weight: bold;
      }
    }
  }
}
.product-code-item {
  margin: 6px 6px;
  cursor: pointer;
}
.erp-id {
  font-size: var(--text-xs1);
  color: #99a1af;
  line-height: 1.2;
  min-width: 0;
}
.product-code-item ::v-deep(.card-content) {
  padding: 8px 10px;
}
.product-code-item ::v-deep(.text-section) {
  min-width: 0;
  flex: 1;
}
.product-code-item ::v-deep(.title) {
  min-width: 0;
}
.icon {
  width: 20px;
}
.empty-bom-list {
  &__header {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: var(--gray-bgcolor);
    display: flex;
    flex-direction: column;

  }

  h3 {
    font-size: var(--text-2xl);
    font-weight: 500;
  }
}
.red-border {
  border: 1px solid red;
}
.bom-list-container{
  height:100%;
  display: flex;
  .bom-detail-view{
    flex: 1;
    overflow-x: auto;
    overflow-y: auto;
    padding-left: 5px;
  }
}
</style>
